import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import classNames from 'classnames';

const Stars = (num) => {
  let stars = [];
  for (var i = 0; i < num; i++) {
    stars.push(<i className="fa fa-star"></i>)
  };
  for (var i = 0; i < 5 - num; i++) {
    stars.push(<i className="fa fa-star-o"></i>)
  };
  return stars;
}

class MapDetails extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleFavorite = this.handleFavorite.bind(this);
  }
  handleSelect(event) {
    event.preventDefault();
    const {map, map_search} = this.props;
    const downloaded_map = map_search.downloaded_maps.find(({id}) => (id == map._id));
    if(downloaded_map) {
      if(!downloaded_map.visible) {
        this.props.showDownloadedMap(downloaded_map.id);
      }
      else {
        this.props.hideDownloadedMap(downloaded_map.id);
      }
    }
    else {
      this.props.downloadMap(this.props.map._id);
    }
  }
  handleFavorite(id, event) {
    event.preventDefault();
    let favorites = [...user.favorites.map( fave => (fave._id ? fave._id : fave ))];

    if(!favorites.find(favorite => (
      favorite._id ? favorite._id == id : favorite == id
    ))) {
      favorites = [ id, ...favorites];
      this.props.addFavorites({ favorites })
    }
    else {
      this.props.addFavorites({ favorites : favorites.filter(filter => filter == id) })
    }
  }
  render() {
    const {map, map_search, user} = this.props;
    const favorites = user.favorites || [];
    const downloaded_map = map_search.downloaded_maps.find(({id}) => (id == map._id));
    const downloading = map_search.fetching_map_ids.find(id => id == map._id) ? true : false;
    const selected = downloaded_map ? downloaded_map.visible : false;
    const is_favorite = favorites.find((favorite) => typeof favorite === 'string' ? favorite == map._id : favorite._id == map._id) ? true: false;

    const checkboxClass = classNames({
      'fa-square-o' : !selected,
      'fa-check-square' : selected,
    })
    return (
      <section className="panel">
        <header className="panel-heading bg-primary">
          <div className="panel-heading-icon">
            <i className="fa fa-map"></i>
          </div>
        </header>
        {!map.properties ? '' : <div className="panel-body">
          <h3 className="text-weight-semibold mt-sm text-center">{map.properties.title}</h3>
          <hr className="dotted short" />
          <h6 className="text-center">{Stars(map.properties.star_level)}</h6>
          <hr className="dotted short" />

          <h6 className="text-muted">Regions</h6>
          <ul className="list-unstyled">
            {map.properties.states.length > 0 ? (<li>States - {map.properties.states.join(', ')}</li>) : ''}
            {map.properties.cities.length > 0 ? (<li>Cities - {map.properties.cities.join('; ')}</li>) : ''}
          </ul>
          <hr className="dotted short" />
          <h6 className="text-muted">Map Info</h6>
          <ul className="list-unstyled">
            {map.properties.storm_date ? <li><i className="fa fa-calendar"></i> {moment(map.properties.storm_date).format('MMM DD, YYYY')}</li> : ''}
            {map.properties.hail_duration ? <li><i className="fa fa-clock-o"></i> {map.properties.hail_duration} Duration</li> : ''}
            {map.properties.max_house_count ? <li><i className="fa fa-home"></i> {Number(map.properties.max_house_count).toLocaleString()} Houses</li> : ''}
            {map.properties.max_hail_size ? <li><i className="wi-weather5"></i> {map.properties.max_hail_size} '' Hail</li> : ''}
          </ul>
          <hr className="dotted short" />
          <h6 className="text-muted">Details</h6>
          <p className="">{map.properties.description}</p>
        </div>}
        <div className="panel-footer panel-footer-btn-group">
          {downloading ? <a onClick={e => e.preventDefault()} href='#'><i className="fa fa-spinner fa-spin fa-1x fa-fw"></i> Downloading...</a> : <a onClick={this.handleSelect} href="#"><i className={"fa "+checkboxClass}></i> Visible</a>}
          <a onClick={e => {
            e.preventDefault();
            this.props.favoriteMap(map._id);
          }} href="#"><i className={`fa fa-${is_favorite ? 'star' : 'star-o'}`}></i> Favorite</a>
        </div>
      </section>
    );
  }
}

MapDetails.propTypes = {
  map : PropTypes.shape({
    _id : PropTypes.string,
    properties : PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      hail_duration: PropTypes.string,
      max_house_count: PropTypes.string,
      max_wind_speed_direction: PropTypes.string,
      max_wind_speed: PropTypes.string,
      max_hail_size: PropTypes.string,
      cities: PropTypes.array,
      states: PropTypes.array,
      creation_date: PropTypes.string,
      publish_date: PropTypes.string,
      storm_date: PropTypes.string,
      star_level: PropTypes.string,
      price: PropTypes.number
    })
  }),
}

const mapStateToProps = ({connection, map_search}) => ({map_search, user : connection.user});

export default connect(mapStateToProps, Actions)(MapDetails);



// WEBPACK FOOTER //
// ./src/browser/components/maps/map-details.js